import _ from 'lodash'
import Immutable from 'immutable'
import tableMapper from '../../components/search/results/tableMapper'


function parsePageUrl(url) {
    const splitPage = url.split('page=')

    if (splitPage && splitPage.length > 1) {
        return splitPage[1].split("&")[0]
    }

    return null
}

function mapSearchOptions(searchOptions) {
    let pages = _.map(searchOptions.pages, (url, key) => {
        if (key === 'next') {
            return {
                page: 'Next',
                nextPage: parsePageUrl(url)
            }
        }
        if (key === 'previous') {
            return {
                page: 'Previous',
                nextPage: parsePageUrl(url)
            }
        }

        return {
            page: parseInt(key, 10),
            url: url,
            active: _.isEmpty(url)
        }
    })

    return Object.assign({}, searchOptions, {pages: _.sortBy(pages, 'page')})
}

const initPacerSearchResults = Immutable.fromJS({
    data: [],
    receipts: [],
    searchOptions: {},
    filters: {
        case_type: 'Bankruptcy',

        court_id: null,
        case_no: null,
        case_title: null,
        chapter: null,
        filed_from: null,
        filed_to: null,
        closed_from: null,
        closed_to: null,
        dismissed_from: null,
        dismissed_to: null,
        discharged_from: null,
        discharged_to: null,
        nos: null,
        ssn4: null,
        ssntin: null,

        party_name: null,
        last_business_name: null,
        middle_name: null,
        first_name: null,
    }
})

const actionHandlers = {
    RECEIVE_SEARCH_RESULTS: (state, action) => {
        let headerFields = []
        let data = []
        let searchResultsType = 'empty'
        const searchType = state.get('searchType')

        if (!_.isEmpty(action.searchResults.cases)) {
            //result type cases
            data = action.searchResults.cases
            headerFields = tableMapper[searchType].casesHeaderFields
            searchResultsType = 'cases'
        } else if (!_.isEmpty(action.searchResults.parties)) {
            //result type parties
            data = action.searchResults.parties
            headerFields = tableMapper[searchType].partiesHeaderFields
            searchResultsType = 'parties'
        }

        return state.merge({
            searchResultsType: searchResultsType,
            data: data,
            headerFields: headerFields,
            receipts: action.searchResults.receipts || [],
            searchOptions: mapSearchOptions(action.searchOptions)
        })
    },
    RESET_SEARCH_RESULTS: () => {
        return initPacerSearchResults
    },
    UPDATE_FILTER: (state, action) => {
        return state.mergeDeep({filters: action.filter})
    },
    RESET_FILTERS: (state) => {
        return initPacerSearchResults
    },
    REQUEST_VIEW_SEARCH: (state) => {
        return state
    },
    REQUEST_BANKRUPTCY_SEARCH: (state) => {
        return initPacerSearchResults.mergeDeep({
            filters: state.get('filters'),
            searchType: 'Bankruptcy',
            query_type: 'search',
        })
    },
    REQUEST_BANKRUPTCY_LOCAL_SEARCH: (state) => {
        return initPacerSearchResults.mergeDeep({
            filters: state.get('filters'),
            searchType: 'Bankruptcy',
            query_type: 'search',
        })
    },
    REQUEST_CIVIL_SEARCH: (state) => {
        return initPacerSearchResults.mergeDeep({
            filters: state.get('filters'),
            searchType: 'Civil',
            query_type: 'search_cv',
        })
    },
    REQUEST_CRIMINAL_SEARCH: (state) => {
        return initPacerSearchResults.mergeDeep({
            filters: state.get('filters'),
            searchType: 'Criminal',
            query_type: 'search_cr',
        })
    },

    REQUEST_APPELLATE_SEARCH: (state) => {
        return initPacerSearchResults.mergeDeep({
            filters: state.get('filters'),
            searchType: 'Appellate',
            query_type: 'search_appellate',
        })
    },
}

export default (pacerSearchResults = initPacerSearchResults, action) => {
    const actionHandler = actionHandlers[action.type]

    return (actionHandler)
        ? actionHandler(pacerSearchResults, action)
        : pacerSearchResults
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/pacerSearchResults.js
 **/